import React, { useState } from 'react';
import {
    Box,
    Button,
    Heading,
    Layer,
    Select,
    SelectMultiple,
    Text,
    TextArea,
    TextInput,
} from 'grommet';
import { Close } from 'grommet-icons';
import { ContactService, Utils } from '@enrich/shared-lib';

export const BulkMessageButton = ({ candidacyStatusEnums, companySlug, job }) => {
    const [showModal, setShowModal] = useState(false);

    return (
        <Box>
            <Button
                primary
                size="large"
                label="Message candidates"
                onClick={() => setShowModal(true)}
            />
            {showModal && (
                <BulkMessageModal
                    candidacyStatusEnums={candidacyStatusEnums}
                    companySlug={companySlug}
                    job={job}
                    setShowModal={setShowModal}
                />
            )}
        </Box>
    );
};

const BulkMessageModal = ({
    candidacyStatusEnums,
    companySlug,
    job,
    setShowModal,
}) => {
    const [message, setMessage] = useState('');
    const [messageType, setMessageType] = useState('email');
    const [subject, setSubject] = useState('');
    const [candidacyStatuses, setCandidacyStatuses] = useState([]);
    const [buttonBusy, setButtonBusy] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');

    const candidacyStatusOptions = candidacyStatusEnums.map((x) => ({
        ...x,
        label: Utils.convertEnumStringToLabel(x.name),
    }));

    const isSendDisabled = !message.length || !candidacyStatuses.length;

    const handleMessageTypeChange = ({ value }) => {
        setMessageType(value);
        setSubject('');
    };

    const sendMessage = async () => {
        try {
            setButtonBusy(true);
            await new ContactService().sendBulkMessageByStatus(
                companySlug,
                message,
                messageType,
                candidacyStatuses.map((s) => s.name),
                subject,
                job?.id,
            );
            setShowModal(false);
        } catch (error) {
            setErrorMessage(
                error.message || 'There was an issue sending the message.',
            );
            setButtonBusy(false);
        }
    };

    return (
        <Layer
            onClickOutside={() => setShowModal(false)}
            onEsc={() => setShowModal(false)}
            position="center">
            <Box
                background="white"
                pad="medium"
                round="6px"
                border={{ color: 'enrich-green-light', size: '3px' }}
                alignSelf="center"
                gap="30px">
                <Box direction="row" gap="20px" justify="between">
                    <Heading level="3" margin={{ vertical: 'none' }}>
                        Message candidates
                    </Heading>
                    <Box align="end">
                        <Close
                            onClick={() => setShowModal(false)}
                            cursor="pointer"
                        />
                    </Box>
                </Box>
                <Box>
                    <Text weight="bold">Message Type</Text>
                    <Select
                        options={['email', 'sms']}
                        value={messageType}
                        onChange={handleMessageTypeChange}
                    />
                </Box>
                {messageType === 'email' && (
                    <Box>
                        <Text weight="bold">Subject</Text>
                        <TextInput
                            placeholder="Email subject"
                            value={subject}
                            onChange={(event) =>
                                setSubject(event.target.value)
                            }
                        />
                    </Box>
                )}
                <Box>
                    <Text weight="bold">Status Filter</Text>
                    <SelectMultiple
                        options={candidacyStatusOptions}
                        labelKey="name"
                        onChange={({ value }) => setCandidacyStatuses(value)}
                        value={candidacyStatuses}
                    />
                </Box>
                <Box>
                    <Text weight="bold">Message</Text>
                    <TextArea
                        placeholder="Message"
                        value={message}
                        onChange={(event) => setMessage(event.target.value)}
                    />
                </Box>
                <Box>
                    <Button
                        primary
                        size="large"
                        busy={buttonBusy}
                        disabled={isSendDisabled}
                        label="Send message"
                        style={{ width: '220px', height: '50px' }}
                        alignSelf="center"
                        onClick={sendMessage}
                    />
                </Box>
                {errorMessage.length > 0 && (
                    <Box>
                        <Text color="red">{errorMessage}</Text>
                    </Box>
                )}
            </Box>
        </Layer>
    );
};
